// Migration utility for converting old onboarding localStorage values to new format

// Old US topic keys → New US topic keys
const US_TOPIC_MIGRATION = {
    legislativeNews: "LegislativeNews",
    executiveNews: "ExecutiveNews",
    judicialNews: "JudicialNews",
    defenseNews: "DefenseNews",
    economyNews: "EconomyNews",
    electionNews: "ElectionNews",
    environmentNews: "EnvironmentNews",
    foreignAffairsNews: "ForeignAffairsNews",
    healthNews: "HealthNews",
    scienceTechNews: "ScienceTechNews",
    spendingNews: "SpendingNews",
    infrastructureNews: "InfrastructureNews",
    regulationsNews: "RegulationsNews",
    justiceNews: "JusticeNews"
  };
  
  // Old Canada topic keys → New Canada topic keys
  const CANADA_TOPIC_MIGRATION = {
    canadaLegislativeNews: "CanadaLegislativeNews",
    canadaExecutiveNews: "CanadaExecutiveNews",
    canadaJudicialNews: "CanadaJudicialNews",
    canadaDefenseNews: "CanadaDefenseNews",
    canadaEconomyNews: "CanadaEconomyNews",
    canadaElectionNews: "CanadaElectionsNews",
    canadaEnvironmentNews: "CanadaEnvironmentNews",
    canadaForeignAffairsNews: "CanadaForeignAffairsNews",
    canadaHealthNews: "CanadaHealthNews",
    canadaScienceTechNews: "CanadaScienceTechNews",
    canadaInfrastructureNews: "CanadaInfrastructureNews",
    canadaJusticeNews: "CanadaJusticeNews"
  };
  
  // Old Mexico topic keys → New Mexico topic keys
  const MEXICO_TOPIC_MIGRATION = {
    mexicoLegislativeNews: "MexicoLegislativeNews",
    mexicoExecutiveNews: "MexicoExecutiveNews",
    mexicoJudicialNews: "MexicoJudicialNews",
    mexicoDefenseNews: "MexicoDefenseNews",
    mexicoEconomyNews: "MexicoEconomyNews",
    mexicoElectionNews: "MexicoElectionsNews",
    mexicoEnvironmentNews: "MexicoEnvironmentNews",
    mexicoForeignAffairsNews: "MexicoForeignAffairsNews",
    mexicoHealthNews: "MexicoHealthNews",
    mexicoScienceTechNews: "MexicoScienceTechNews",
    mexicoInfrastructureNews: "MexicoInfrastructureNews",
    mexicoJusticeNews: "MexicoJusticeNews"
  };
  
  // Old UK topic keys → New UK topic keys
  const UK_TOPIC_MIGRATION = {
    ukLegislativeNews: "UKLegislativeNews",
    ukExecutiveNews: "UKExecutiveNews",
    ukJudicialNews: "UKJudicialNews",
    ukDefenseNews: "UKDefenseNews",
    ukEconomyNews: "UKEconomyNews",
    ukElectionNews: "UKElectionsNews",
    ukEnvironmentNews: "UKEnvironmentNews",
    ukForeignAffairsNews: "UKForeignAffairsNews",
    ukHealthNews: "UKHealthNews",
    ukScienceTechNews: "UKScienceTechNews",
    ukInfrastructureNews: "UKInfrastructureNews",
    ukJusticeNews: "UKJusticeNews"
  };
  
  // Old US state keys (with "News" suffix) → New state keys (without suffix)
  const US_STATE_MIGRATION = {
    alabamaNews: "alabama",
    alaskaNews: "alaska",
    arizonaNews: "arizona",
    arkansasNews: "arkansas",
    californiaNews: "california",
    coloradoNews: "colorado",
    connecticutNews: "connecticut",
    delawareNews: "delaware",
    floridaNews: "florida",
    georgiaNews: "georgia",
    hawaiiNews: "hawaii",
    idahoNews: "idaho",
    illinoisNews: "illinois",
    indianaNews: "indiana",
    iowaNews: "iowa",
    kansasNews: "kansas",
    kentuckyNews: "kentucky",
    louisianaNews: "louisiana",
    maineNews: "maine",
    marylandNews: "maryland",
    massachusettsNews: "massachusetts",
    michiganNews: "michigan",
    minnesotaNews: "minnesota",
    mississippiNews: "mississippi",
    missouriNews: "missouri",
    montanaNews: "montana",
    nebraskaNews: "nebraska",
    nevadaNews: "nevada",
    newHampshireNews: "newhampshire",
    newJerseyNews: "newjersey",
    newMexicoNews: "newmexico",
    newYorkNews: "newyork",
    northCarolinaNews: "northcarolina",
    northDakotaNews: "northdakota",
    ohioNews: "ohio",
    oklahomaNews: "oklahoma",
    oregonNews: "oregon",
    pennsylvaniaNews: "pennsylvania",
    rhodeIslandNews: "rhodeisland",
    southCarolinaNews: "southcarolina",
    southDakotaNews: "southdakota",
    tennesseeNews: "tennessee",
    texasNews: "texas",
    utahNews: "utah",
    vermontNews: "vermont",
    virginiaNews: "virginia",
    washingtonNews: "washington",
    westVirginiaNews: "westvirginia",
    wisconsinNews: "wisconsin",
    wyomingNews: "wyoming"
  };
  
  // Old Canada province keys → New province keys
  const CANADA_PROVINCE_MIGRATION = {
    albertaNews: "alberta",
    britishColumbiaNews: "british_columbia",
    manitobaNews: "manitoba",
    newBrunswickNews: "new_brunswick",
    newfoundlandAndLabradorNews: "newfoundland_labrador",
    northwestTerritoriesNews: "northwest_territories",
    novaScotiaNews: "nova_scotia",
    nunavutNews: "nunavut",
    ontarioNews: "ontario",
    princeEdwardIslandNews: "prince_edward_island",
    quebecNews: "quebec",
    saskatchewanNews: "saskatchewan",
    yukonNews: "yukon"
  };
  
  // Old Mexico state keys → New state keys
  const MEXICO_STATE_MIGRATION = {
    aguascalientesNews: "aguascalientes",
    bajaCaliforniaNews: "bajacalifornia",
    bajaCaliforniaSurNews: "bajacaliforniasur",
    campecheNews: "campeche",
    chiapasNews: "chiapas",
    chihuahuaNews: "chihuahua",
    coahuilaNews: "coahuila",
    colimaNews: "colima",
    durangoNews: "durango",
    guanajuatoNews: "guanajuato",
    guerreroNews: "guerrero",
    hidalgoNews: "hidalgo",
    jaliscoNews: "jalisco",
    mexicoStateNews: "mexicostate",
    mexicoCityNews: "mexicocity",
    michoacanNews: "michoacan",
    morelosNews: "morelos",
    nayaritNews: "nayarit",
    nuevoLeonNews: "nuevoleon",
    oaxacaNews: "oaxaca",
    pueblaNews: "puebla",
    queretaroNews: "queretaro",
    quintanaRooNews: "quintanaroo",
    sanLuisPotosiNews: "sanluispotosi",
    sinaloaNews: "sinaloa",
    sonoraNews: "sonora",
    tabascoNews: "tabasco",
    tamaulipasNews: "tamaulipas",
    tlaxcalaNews: "tlaxcala",
    veracruzNews: "veracruz",
    yucatanNews: "yucatan",
    zacatecasNews: "zacatecas"
  };
  
  // Old UK kingdom keys → New region keys
  const UK_REGION_MIGRATION = {
    englandNews: "england",
    scotlandNews: "scotland",
    walesNews: "wales",
    northernIrelandNews: "northernireland"
  };
  
  /**
   * Migrates old onboarding localStorage values to new format
   * Returns migration result with detected country and migrated values
   */
  export const migrateOnboardingData = () => {
    const migrationResult = {
      hasMigrated: false,
      detectedCountry: null,
      homeState: null,
      homeProvince: null,
      homeMexicanState: null,
      homeUKRegion: null,
      migratedTopics: []
    };
  
    // Check for old US state data
    const oldHomeState = localStorage.getItem("homeState");
    if (oldHomeState && US_STATE_MIGRATION[oldHomeState]) {
      const newStateKey = US_STATE_MIGRATION[oldHomeState];
      localStorage.setItem("homeState", newStateKey);
      localStorage.setItem("homeCountry", "us");
      localStorage.setItem(newStateKey, "true");
      migrationResult.hasMigrated = true;
      migrationResult.detectedCountry = "us";
      migrationResult.homeState = newStateKey;
    }
  
    // Check for old Canada province data
    const oldHomeProvince = localStorage.getItem("homeProvince");
    if (oldHomeProvince && CANADA_PROVINCE_MIGRATION[oldHomeProvince]) {
      const newProvinceKey = CANADA_PROVINCE_MIGRATION[oldHomeProvince];
      localStorage.setItem("homeProvince", newProvinceKey);
      localStorage.setItem("homeCountry", "ca");
      migrationResult.hasMigrated = true;
      migrationResult.detectedCountry = "ca";
      migrationResult.homeProvince = newProvinceKey;
    }
  
    // Check for old Mexico state data
    const oldMexicoState = localStorage.getItem("mexicoHomeState");
    if (oldMexicoState && MEXICO_STATE_MIGRATION[oldMexicoState]) {
      const newStateKey = MEXICO_STATE_MIGRATION[oldMexicoState];
      localStorage.setItem("homeMexicanState", newStateKey);
      localStorage.setItem("homeCountry", "mx");
      // Remove old key
      localStorage.removeItem("mexicoHomeState");
      migrationResult.hasMigrated = true;
      migrationResult.detectedCountry = "mx";
      migrationResult.homeMexicanState = newStateKey;
    }
  
    // Check for old UK kingdom data
    const oldHomeKingdom = localStorage.getItem("homeKingdom");
    if (oldHomeKingdom && UK_REGION_MIGRATION[oldHomeKingdom]) {
      const newRegionKey = UK_REGION_MIGRATION[oldHomeKingdom];
      localStorage.setItem("homeUKRegion", newRegionKey);
      localStorage.setItem("homeCountry", "uk");
      // Remove old key
      localStorage.removeItem("homeKingdom");
      migrationResult.hasMigrated = true;
      migrationResult.detectedCountry = "uk";
      migrationResult.homeUKRegion = newRegionKey;
    }
  
    // Migrate US topics
    Object.entries(US_TOPIC_MIGRATION).forEach(([oldKey, newKey]) => {
      if (localStorage.getItem(oldKey) === "true") {
        localStorage.setItem(newKey, "true");
        localStorage.removeItem(oldKey);
        migrationResult.migratedTopics.push(newKey);
        if (!migrationResult.detectedCountry) {
          migrationResult.detectedCountry = "us";
          localStorage.setItem("homeCountry", "us");
        }
        migrationResult.hasMigrated = true;
      }
    });
  
    // Migrate Canada topics
    Object.entries(CANADA_TOPIC_MIGRATION).forEach(([oldKey, newKey]) => {
      if (localStorage.getItem(oldKey) === "true") {
        localStorage.setItem(newKey, "true");
        localStorage.removeItem(oldKey);
        migrationResult.migratedTopics.push(newKey);
        if (!migrationResult.detectedCountry) {
          migrationResult.detectedCountry = "ca";
          localStorage.setItem("homeCountry", "ca");
        }
        migrationResult.hasMigrated = true;
      }
    });
  
    // Migrate Mexico topics
    Object.entries(MEXICO_TOPIC_MIGRATION).forEach(([oldKey, newKey]) => {
      if (localStorage.getItem(oldKey) === "true") {
        localStorage.setItem(newKey, "true");
        localStorage.removeItem(oldKey);
        migrationResult.migratedTopics.push(newKey);
        if (!migrationResult.detectedCountry) {
          migrationResult.detectedCountry = "mx";
          localStorage.setItem("homeCountry", "mx");
        }
        migrationResult.hasMigrated = true;
      }
    });
  
    // Migrate UK topics
    Object.entries(UK_TOPIC_MIGRATION).forEach(([oldKey, newKey]) => {
      if (localStorage.getItem(oldKey) === "true") {
        localStorage.setItem(newKey, "true");
        localStorage.removeItem(oldKey);
        migrationResult.migratedTopics.push(newKey);
        if (!migrationResult.detectedCountry) {
          migrationResult.detectedCountry = "uk";
          localStorage.setItem("homeCountry", "uk");
        }
        migrationResult.hasMigrated = true;
      }
    });
  
    // Clean up old onboarding flags
    if (localStorage.getItem("ukOnboarding") === "true") {
      localStorage.removeItem("ukOnboarding");
    }
  
    return migrationResult;
  };
  
  /**
   * Gets currently stored topics from localStorage in new format
   */
  export const getStoredTopics = (country) => {
    const storedTopics = [];
    
    let topicKeys = [];
    if (country === "us") {
      topicKeys = Object.values(US_TOPIC_MIGRATION);
    } else if (country === "ca") {
      topicKeys = Object.values(CANADA_TOPIC_MIGRATION);
    } else if (country === "mx") {
      topicKeys = Object.values(MEXICO_TOPIC_MIGRATION);
    } else if (country === "uk") {
      topicKeys = Object.values(UK_TOPIC_MIGRATION);
    }
  
    topicKeys.forEach(key => {
      if (localStorage.getItem(key) === "true") {
        storedTopics.push(key);
      }
    });
  
    return storedTopics;
  };
  
  export default migrateOnboardingData;